<div class="renderer-wrapper">
  <div class="logo-container">
    <img
      class="circle-img"
      [src]="params.data.logoUrl"
      alt="Organization Details"
      (error)="handleImageError(params)"
      *ngIf="!params.logoUrlIsNotValid; else logoUrlIsNotValid"
    />
  </div>
  <div class="details-container">
    <div
      class="body-2-bold"
      [raUiBadge]="params.data.status === 'Archived' ? 'Archived' : ''"
      [badgeConfig]="badgeConfig"
    >
      {{ params.data.name }}
    </div>
    <div>
      {{ params.data.description }}
    </div>
  </div>
</div>

<ng-template #logoUrlIsNotValid>
  <img class="circle-img" alt [src]="defaultLogoUrl" />
</ng-template>
